import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'search-narrow_search_empty_and_results_with_empty_or_results-view';

/**
 * We are using this to track the query and category path pairs that leads to a search page with empty AND results as well as empty OR results.
1. query
2. category_path
3. Request ID
 */
export function trackSearchNarrowSearchEmptyAndResultsWithEmptyOrResultsView(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
